import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ElementRenderer, generateElementKey } from '../ElementRenderer.js';
import { getLayoutStyles } from '../layout.js';
import { cn } from '../lib/utils.js';
import { ScrollArea, ScrollBar } from '../ui/scroll-area.js';
/**
 * Scroll container element using shadcn/ui ScrollArea
 * Adds styled scrollbars based on direction:
 * - :row → horizontal scroll
 * - :col → vertical scroll (default)
 *
 * Also includes native overflow fallback for SSG
 */
export function Scroll({ element }) {
    const layoutStyles = getLayoutStyles(element);
    const { props } = element;
    const isHorizontal = props.row === true;
    // Merge native overflow styles for SSG fallback
    const scrollStyles = {
        ...layoutStyles,
        overflow: 'auto',
        overflowX: isHorizontal ? 'auto' : 'hidden',
        overflowY: isHorizontal ? 'hidden' : 'auto',
    };
    return (_jsxs(ScrollArea, { className: cn('box-border'), style: scrollStyles, children: [_jsx("div", { className: cn(isHorizontal ? 'flex flex-row' : 'flex flex-col'), style: {
                    gap: layoutStyles.gap,
                }, children: element.children.map((child, index) => (_jsx(ElementRenderer, { node: child }, generateElementKey(child, index)))) }), isHorizontal && _jsx(ScrollBar, { orientation: "horizontal" })] }));
}
//# sourceMappingURL=Scroll.js.map